import { render, staticRenderFns } from "./changePassWorld.vue?vue&type=template&id=2fbacf76&"
import script from "./changePassWorld.vue?vue&type=script&lang=js&"
export * from "./changePassWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports